module.exports = __webpack_public_path__ + "img/paso2-img.93435453.png";